import React, { useEffect, useRef, useState } from "react";

import CustomModal from "../../Common/Modal/CustomModal";
import ReCAPTCHA from "react-google-recaptcha";
import { fetchContactFormSent } from "../../../actions/Site/global";
import { isValidEmail } from "../../../utils";
import { useDispatch } from "react-redux";
import { useModalToggle } from "../../../hooks/useModalToggle";
import { useNavigate } from "react-router-dom";

const ContactFormLanding = ({
  t,
  type,
  title,
  desc,
  phone,
  isEmail = false,
  emailText,
}) => {
  const initialState = {
    acName: "",
    acSubject: "",
    acEmail: "",
    acMessage: "",
    acToken: "",
    type: type,
  };
  const initialStateErrors = {
    acName: "",
    acSubject: "",
    acEmail: "",
  };

  const key = "6Lf4BCEpAAAAAHOfwHw8Vsrjl0dXZHnk8vyi_G5f"; //oktacron.rs
  // const key = "6LfjRhkpAAAAAMbjLM75pWi_-rso2rHUxEkj7Cbd"; //api.oktacron.rs
  // const key = "6LeUftEoAAAAAGV2wD_uDEKaIrwHMZFw7sKDgkC9"; //localhost

  const [formData, setFormData] = useState(initialState);
  const [errors, setErrors] = useState(initialStateErrors);
  const [errorMessage, setErrorMessage] = useState("");
  const recaptchaRef = useRef();

  const [showMessage, setShowMessage] = useState(false);
  const [showMessageError, setShowMessageError] = useState(false);
  const [isValid, setIsValid] = useState(true);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [showModal, toggleModal] = useModalToggle(false);

  useEffect(() => {
    getToken();
  }, []);

  const getToken = async () => {
    if (recaptchaRef?.current) {
      const token = await recaptchaRef?.current.executeAsync();
      setFormData((prevData) => ({ ...prevData, acToken: token }));
    }
  };

  const handleSubmit = async (event) => {
    event.preventDefault();

    // Validacija
    const newErrors = {};
    if (!formData.acName) {
      newErrors.acName = t("contact.input-required");
    }
    if (!formData.acSubject) {
      newErrors.acSubject = t("contact.input-required");
    }
    if (!formData.acEmail) {
      newErrors.acEmail = t("contact.input-required");
    }
    if (!formData.acMessage) {
      newErrors.acMessage = t("contact.input-required");
    }

    setErrors(newErrors);
    if (Object.keys(newErrors).length === 0) {
      if (isValid === false) {
        setErrors({ acEmail: t("contact.input-required") });
        setErrorMessage(t("contact.email-error"));
        setShowMessage(false);
        setShowMessageError(true);
        setTimeout(() => {
          setShowMessageError(false);
        }, 3000);
      } else {
        if (formData.acToken)
          dispatch(
            fetchContactFormSent(
              formData,
              showMessageContact,
              showServerErrorMessage,
              navigate
            )
          );
      }
    } else {
      setErrorMessage(t("contact.message-error"));
      setShowMessage(false);
      setShowMessageError(true);
      setTimeout(() => {
        setShowMessageError(false);
      }, 3000);
    }
  };

  function handleInputChange(event) {
    const { name, value } = event.target;
    setFormData({
      ...formData,
      [name]: value,
    });
  }

  const handleInputChangeEmail = (event) => {
    const { name, value } = event.target;
    setIsValid(isValidEmail(value));

    setFormData((prevUser) => ({
      ...prevUser,
      [name]: value,
    }));
  };

  const modalCloseHandler = () => {
    toggleModal(false);
  };

  const showMessageContact = () => {
    // setShowMessage(true);
    toggleModal();
    setShowMessageError(false);

    setTimeout(() => {
      toggleModal();
    }, 60000);

    setFormData({
      acName: "",
      acSubject: "",
      acEmail: "",
      acMessage: "",
      acToken: "",
      type: type,
    });
    getToken();
    setErrors(initialStateErrors);
  };

  const showServerErrorMessage = () => {
    setErrorMessage(t("contact.server-error"));
    setShowMessage(false);
    setShowMessageError(true);

    setTimeout(() => {
      window.location.reload();
    }, 5000);
  };

  return (
    <>
      <div className="contact-form-landing-holder" id="forma">
        <div className="contanct-form-landing-content">
          <h3>{title}</h3>
          <h4>{desc}</h4>
          <div className="contact-form-info-messages">
            {showMessage && (
              <div className={`text-form-message ${showMessage && "active"}`}>
                {t("contact.message")}
              </div>
            )}
            {showMessageError && (
              <div
                className={`text-form-message ${
                  showMessageError && "active"
                }`}
              >
                {errorMessage}
              </div>
            )}
          </div>
          <div className="contact-form-lading-content-form">
            <form onSubmit={handleSubmit}>
              <ReCAPTCHA sitekey={key} size="invisible" ref={recaptchaRef} />
              <div className="des-block1">
                <div className="row">
                  <div className="col-lg-12 col-sm-12">
                    <input
                      className={`form-control ${
                        errors.acName && "has-error-input"
                      }`}
                      type="text"
                      name="acName"
                      value={formData.acName}
                      placeholder={t("contact.placeholder-name")}
                      onChange={handleInputChange}
                    />

                    <input
                      className={`form-control ${
                        errors.acEmail && "has-error-input"
                      }`}
                      type="text"
                      name="acEmail"
                      value={formData.acEmail}
                      placeholder={t("contact.placeholder-email")}
                      onChange={handleInputChangeEmail}
                    />
                    <input
                      className={`form-control ${
                        errors.acSubject && "has-error-input"
                      }`}
                      type="text"
                      name="acSubject"
                      placeholder={t("contact.placeholder-subject")}
                      value={formData.acSubject}
                      onChange={handleInputChange}
                    />

                    <textarea
                      className={`form-control ${
                        errors.acMessage && "has-error-input"
                      }`}
                      name="acMessage"
                      placeholder={t("contact.placeholder-message")}
                      value={formData.acMessage}
                      onChange={handleInputChange}
                      rows="4"
                    />
                  </div>
                </div>
                <div className="submit-form-button">
                  <button
                    type="submit"
                    className="custom-contact-button"
                    style={{ border: "none" }}
                  >
                    {t("contact.button")}
                  </button>
                  {/* <div className="contanct-info-mobile-form">
                    {isEmail ? (
                      <>
                        {emailText}:{" "}
                        <a href={`mailto:jovana.djinovic@oktacron.rs`}>
                          jovana.djinovic@oktacron.rs
                        </a>
                      </>
                    ) : (
                      <>
                        {phone}:{" "}
                        <a href="tel:+381607048644">+381 60 704 8644</a>
                      </>
                    )}
                  </div> */}
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
      {showModal && (
        <CustomModal
          backdrop={false}
          centered={true}
          footerContent={false}
          modalTitle={t("contact.messageTitle")}
          show={showModal}
          hideModal={modalCloseHandler}
        >
          <div
            dangerouslySetInnerHTML={{
              __html: t("contact.message2"),
            }}
          />
        </CustomModal>
      )}
    </>
  );
};

export default ContactFormLanding;
